import { render, staticRenderFns } from "./exhibition-business.vue?vue&type=template&id=6c4fd28e&scoped=true&"
import script from "./exhibition-business.vue?vue&type=script&lang=js&"
export * from "./exhibition-business.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-business.vue?vue&type=style&index=0&id=6c4fd28e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4fd28e",
  null
  
)

export default component.exports